// src/components/Countries/CountriesList.js
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCountries, deleteCountry } from '../../../redux/Country/actions';
import { List, Button, Modal } from 'antd';
import CountryDrawer from './CountryDrawer';

const CountriesList = () => {
  const dispatch = useDispatch();
  const { countries, error } = useSelector(state => state.countries);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editingCountryId, setEditingCountryId] = useState(null);

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const showDrawer = (id) => {
    setEditingCountryId(id);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setEditingCountryId(null);
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <Button type="primary" onClick={() => showDrawer(null)}>
        Add Country
      </Button>
      <List
        itemLayout="horizontal"
        dataSource={countries}
        renderItem={country => (
          <List.Item
            actions={[
                

              <Button key="edit" onClick={() => showDrawer(country._id)}>
                Edit
              </Button>,
              <Button key="delete" onClick={() => dispatch(deleteCountry(country._id))}>
                Delete
              </Button>
            ]}
          >
            <List.Item.Meta
              title={country.name}
            />
          </List.Item>
        )}
      />
      <CountryDrawer visible={drawerVisible} onClose={closeDrawer} _id={editingCountryId} />
    </div>
  );
};

export default CountriesList;
